module.exports = __webpack_public_path__ + "img/red-peppers.5959b57d.webp";